const TicketConstants = {
  GET_TICKET_SUCCESS: "GET_TICKET_SUCCESS",
  GET_TICKET_FAILURE: "GET_TICKET_FAILURE",
  GET_TICKET_DETAILS_SUCCESS: "GET_TICKET_DETAILS_SUCCESS",
  GET_TICKET_DETAILS_FAILURE: "GET_TICKET_DETAILS_FAILURE",
  UPDATE_TICKET_STATUS_SUCCESS: "UPDATE_TICKET_STATUS_SUCCESS",
  UPDATE_TICKET_STATUS_FAILURE: "UPDATE_TICKET_STATUS_FAILURE",
  UPDATE_TICKET_STATUS_DETAIL_SUCCESS: "UPDATE_TICKET_STATUS_DETAIL_SUCCESS",
  UPDATE_TICKET_STATUS_DETAIL_FAILURE: "UPDATE_TICKET_STATUS_DETAIL_FAILURE",
  UPDATE_PUBLIC_TICKET_STATUS_SUCCESS: "UPDATE_PUBLIC_TICKET_STATUS_SUCCESS",
  UPDATE_PUBLIC__TICKET_STATUS_FAILURE: "UPDATE_PUBLIC__TICKET_STATUS_FAILURE",
  UPDATE_MUL_TICKET_STATUS_SUCCESS: "UPDATE_MUL_TICKET_STATUS_SUCCESS",
  UPDATE_MUL_TICKET_STATUS_FAILURE: "UPDATE_MUL_TICKET_STATUS_FAILURE",
  GET_EQUIPMENT_TICKET_SUCCESS: "GET_EQUIPMENT_TICKET_SUCCESS",
  GET_EQUIPMENT_TICKET_FAILURE: "GET_EQUIPMENT_TICKET_FAILURE",
};
export default TicketConstants;
